import Swiper, { Navigation, Pagination, Autoplay } from 'swiper'

import 'swiper/css'
Swiper.use([Navigation, Pagination, Autoplay])

const enableSwipers = function () {
  document
    .querySelectorAll('.swiper:not(.featured-content-slider)')
    .forEach((el) => {
      let mobile = window.matchMedia('(min-width: 0px) and (max-width: 768px)')
      let desktop = window.matchMedia('(min-width: 1025px)')
      let parentContainer = el.closest('.slider')
      let paginationEl = parentContainer.querySelector('.swiper-pagination')
      let navigationPrev = parentContainer.querySelector('.swiper-button-prev')
      let navigationNext = parentContainer.querySelector('.swiper-button-next')
      let hasTextPagination = el.hasAttribute('data-text-pagination')
      let desktopSlidesPerView = parseInt(
        el.getAttribute('data-desktop-slides-per-view')
      )
      let mobileSlidesPerView = parseInt(
        el.getAttribute('data-mobile-slides-per-view')
      )

      let swiper = new Swiper(el, {
        slidesPerView: mobileSlidesPerView,
        slidesPerGroup: mobileSlidesPerView,
        freemode: true,
        preloadImages: false,
        loop: false,
        watchSlidesProgress: true,
        speed: 800,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView: mobileSlidesPerView,
            slidesPerGroup: mobileSlidesPerView,
            spaceBetween: 16,
          },
          767: {
            spaceBetween: 24,
          },
          992: {
            spaceBetween: 36,
            slidesPerView: desktopSlidesPerView,
            slidesPerGroup: desktopSlidesPerView,
            freemode: false,
          },
        },
        navigation: {
          prevEl: navigationPrev,
          nextEl: navigationNext,
        },
      })

      if (swiper.slides.length > mobileSlidesPerView) {
        swiper.params.breakpoints[0].slidesPerView = mobileSlidesPerView + 0.25
        swiper.currentBreakpoint = false
        swiper.update()
      }

      if (swiper.slides.length > desktopSlidesPerView) {
        swiper.params.breakpoints[992].slidesPerView =
          desktopSlidesPerView + 0.25
        swiper.currentBreakpoint = false
        swiper.update()
      }

      swiper.on('transitionStart', () => {
        var videos = parentContainer.querySelectorAll('video')

        Array.prototype.forEach.call(videos, function (video) {
          video.pause()
        })
      })

      swiper.on('transitionEnd', () => {
        var activeIndex = swiper.activeIndex
        var activeSlide =
          parentContainer.getElementsByClassName('swiper-slide')[activeIndex]
        var activeSlideVideo = activeSlide.getElementsByTagName('video')[0]
        if (activeSlideVideo) {
          activeSlideVideo.play()
        }
      })

      swiper.on('slideChange', () => {
        swiper.pagination.render()
        swiper.pagination.update()
      })

      if (hasTextPagination) {
        var videos = parentContainer.querySelectorAll('video')

        Array.prototype.forEach.call(videos, function (video) {
          video.pause()
        })

        swiper.params.breakpoints[0].slidesPerView = 1
        swiper.params.breakpoints[0].slidesPerGroup = 1
        swiper.params.breakpoints[992].slidesPerView = 'auto'
        swiper.params.breakpoints[992].slidesPerGroup = 1
        swiper.currentBreakpoint = false
        swiper.update()

        let featureItems = parentContainer.querySelectorAll('.feature__item')

        swiper.on('slideChange', () => {
          featureItems.forEach((featureItem) => {
            featureItem.classList.remove('active')
          })

          featureItems[swiper.realIndex].classList.add('active')
        })

        featureItems.forEach((featureItem, index) => {
          featureItem.addEventListener('click', () => {
            swiper.slideToLoop(index)
          })
        })
      }
    })
}

enableSwipers()

// window.addEventListener('resize', function () {
//   enableSwipers()
// })

let lastW = window.innerWidth;
window.addEventListener('resize', () => {
  const w = window.innerWidth;
  if (w !== lastW) {
    lastW = w;
    enableSwipers()
    // re-run enableSwipers() only if you truly must re-create them
  }
});


if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    enableSwipers()
  })
}
